<template>
    <div>
        <form action="#" v-if="displayForm" @submit.prevent="save()">
            <field-input v-model="form.name" name="name" placeholder="Name" :required="true"></field-input>
            <field-input v-model="form.personal_email" name="email" placeholder="Personal Email" :required="true"></field-input>
            <field-phone v-model="form.phone" placeholder="Cell Phone"></field-phone>
            <field-input v-model="form.address" placeholder="Home Address" id="autocomplete-address"></field-input>
            <field-input v-model="form.city" name="city" placeholder="City"></field-input>
            <field-input v-model="form.state" name="state" placeholder="State"></field-input>
            <field-input v-model="form.zip" name="zip" placeholder="Zip"></field-input>
            <submit-button type="submit" :form="form" :class="btnClass">Save</submit-button>
        </form>
    </div>
</template>
<script>
  let AutoCompleteAddress = require('@/mixins/AutoCompleteAddress');

  export default {

    mixins: [AutoCompleteAddress],

        props: {
            user: {
                type: Object,
                required: true,
            },
            showForm:{
                type: Boolean,
                required: false,
                default: false,
            },
            refresh:{
                type: Boolean,
                required: false,
                default: false,
            },
            btnClass:{
                type: String,
                required: false,
                default: '',
            }
        },

        data(){
            return {
                displayForm: this.showForm,
                form: new Form(this.user).dontClear(),
            }
        },

        mounted() {
            $(`#application-tabs`).on('shown.bs.tab', event => {
                if (event.target.id == 'personal-tab') {
                    this.displayForm = true;
                    this.$nextTick(() => {
                        this.createAutocompleteAddress()
                    })
                }
            })
        },

        methods:{

            save(){
                this.form.patch(`/account`).then(response => {
                    if(this.refresh) {
                        Alert.withAction('Personal Information Updated').then(() => {
                            this.refreshPage();
                        })
                        return;
                    }else{
                        Alert.success('Personal Information Updated')
                    }
                    this.$emit('success');
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            },

            setAddressFromPlace(place) {

                this.addressParts.street_number.to = 'address';
                this.addressParts.route.to = 'address';

                for (var key in this.addressParts) {
                    this.form[this.addressParts[key].to] = '';
                }


                for (var i = 0; i < place.address_components.length; i++) {
                    var addressType = place.address_components[i].types[0];
                    if (this.addressParts[addressType]) {
                        var val = (this.addressParts[addressType].join + place.address_components[i][this.addressParts[addressType].key]);
                        this.form[this.addressParts[addressType].to] += val;
                    }
                }
            },
        }
    }
</script>